/**
 * @author Arul Vivek
 */

import constants, { HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

/** Create a Marketplace account */
function createAccount(payload) {
    return axiosClient({
        url: constants.api.marketplace.createAccount,
        method: HTTP_METHODS.POST,
        headers: { "Content-Type": "application/json" },
        data: payload,
    }).then((res) => res?.data ?? res);
}

/** Validate Marketplace setup and retrieve the response token */
function validate() {
    return axiosClient({
        url: constants.api.marketplace.validate,
        method: HTTP_METHODS.GET,
    }).then((res) => res?.data ?? res);
}

/** Test email is not available yet */
function sendTestEmail() {
    return Promise.reject(
        new Error("Test email is not available yet")
    );
}

const MarketplaceService = {
    createAccount,
    validate,
    sendTestEmail,
};

export default MarketplaceService;